import React from "react";
import { Alert, Link as MuiLink } from "@mui/material";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { useDuplicateUniqueNrProperties } from "../../hooks/property.hooks";

interface DuplicateUniqueNrWarningProps {
  uniqueNr?: string;
  /** Property to exclude from the duplicate check (e.g. the property being edited / viewed). */
  excludePropertyId?: string;
  /** When true, opens the duplicate property links in a new tab. */
  openInNewTab?: boolean;
  style?: React.CSSProperties;
}

export const DuplicateUniqueNrWarning: React.FC<
  DuplicateUniqueNrWarningProps
> = ({ uniqueNr, excludePropertyId, openInNewTab = true, style }) => {
  const { t } = useTranslation();
  const { duplicates } = useDuplicateUniqueNrProperties(
    uniqueNr,
    excludePropertyId
  );

  if (duplicates.length === 0) {
    return null;
  }

  return (
    <Alert severity="warning" style={style}>
      {t("duplicateUniqueNr.title", { count: duplicates.length })}
      <ul style={{ margin: "8px 0 0", paddingLeft: 20 }}>
        {duplicates.map((property) => (
          <li key={property._id}>
            <MuiLink
              component={Link}
              to={`/properties/${property._id}`}
              target={openInNewTab ? "_blank" : undefined}
              rel={openInNewTab ? "noopener noreferrer" : undefined}
            >
              {property.label || property.address || property.uniqueNr}
            </MuiLink>
            {!!property.createdAt && (
              <> ({dayjs(property.createdAt).format("YYYY-MM-DD")})</>
            )}
          </li>
        ))}
      </ul>
    </Alert>
  );
};
